export class AboutUsService {
  scrollToSection(sectionId: string) {
    const sectionToScrollTo = document.getElementById(sectionId);
    sectionToScrollTo?.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  scrollToVision(sectionId: string, currentLocationHash: string) {
    if (currentLocationHash !== "#vision") return;

    this.scrollToSection(sectionId);
  }
}
